import { useCallback, useEffect, useState } from 'react';
import { api } from '@/App';
import AdminSidebar from '@/components/AdminSidebar';
import { QrStatCards, QrClicksList, QrDailyChart } from '@/components/qr/QrStats';
import { QrDownloads } from '@/components/qr/QrDownloads';
import { QrWeeklyReport } from '@/components/qr/QrWeeklyReport';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const RANGES = [{ days: 7, label: '7 días' }, { days: 30, label: '30 días' }, { days: 90, label: '90 días' }];

export default function QrStatsPage() {
  const [days, setDays] = useState(30);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get(`/admin/qr/stats?days=${days}`);
      setStats(res.data);
    } catch { toast.error('No se pudieron cargar las métricas del QR'); }
    finally { setLoading(false); }
  }, [days]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="min-h-screen bg-[#F5F4F0] flex">
      <AdminSidebar activeKey="qr" />
      <main className="flex-1 p-4 lg:p-8 lg:ml-0">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-6 ml-12 lg:ml-0">
            <div>
              <h1 className="text-2xl font-bold text-[#1C1917]" style={{ fontFamily: 'Outfit' }} data-testid="qr-stats-title">Landing QR</h1>
              <p className="text-sm text-[#78716C]">
                Cuántas personas escanean el código y qué botón eligen
                {stats && <> · Total histórico: {stats.all_time.views} aperturas / {stats.all_time.clicks} clics</>}
              </p>
            </div>
            <div className="flex items-center gap-1 bg-white rounded-full p-1 border border-[#E7E5E4]" data-testid="qr-range-selector">
              {RANGES.map((r) => (
                <button key={r.days} onClick={() => setDays(r.days)}
                  className={`px-3 py-1.5 rounded-full text-sm transition-colors ${days === r.days ? 'bg-[#264639] text-white' : 'text-[#57534E] hover:bg-[#F5F4F0]'}`}
                  data-testid={`qr-range-${r.days}`}>
                  {r.label}
                </button>
              ))}
            </div>
          </div>

          {loading && !stats ? (
            <div className="flex justify-center py-16"><Loader2 className="w-8 h-8 animate-spin text-[#264639]" /></div>
          ) : (
            <>
              <QrStatCards stats={stats} />
              <div className="grid lg:grid-cols-3 gap-4 mt-4">
                <QrDailyChart stats={stats} />
                <QrClicksList stats={stats} />
              </div>
            </>
          )}

          <QrWeeklyReport />

          <QrDownloads qrUrl={stats?.qr_url || 'https://estadia365.com/qr'} />
        </div>
      </main>
    </div>
  );
}
